import { TaxSectionProps } from ".";
import { FullSellerRatesHistory, SightCreditCardConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { CreditCardIcon } from "../../styles/icons/CreditCardIcon";
import { formatPaymentRangeFromApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Text } from "../Sellers/styles";
import { Divider, Header, Section } from "./styles";

interface SightCreditCard extends TaxSectionProps {
  sightCreditCardConfigData: SightCreditCardConfig;
  defaultSightCreditCardConfigData: SightCreditCardConfig;
  actualValue: FullSellerRatesHistory | undefined;
}

export function SightCreditCardModalVisualization({
  sightCreditCardConfigData,
  defaultSightCreditCardConfigData,
  colorFinder,
  actualValue,
}: SightCreditCard) {
  const delayForRedeem = formatTextView("sightCreditCardConfigData", "delayForRedeem", formatPaymentRangeFromApi);
  const rate = formatTextView("sightCreditCardConfigData", "rate", formatPercentageToNumber);
  function formatTextView(paymentMethod: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean): JSX.Element {
    const pastValue = actualValue?.pastSellerRates?.[paymentMethod][innerValue];
    const laterValue = actualValue?.laterSellerRates?.[paymentMethod][innerValue];
    if (pastValue === laterValue) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {formaterAsCurrency ? formater({value: laterValue}) : formater(laterValue)}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultSightCreditCardConfigData[innerValue])}>
            {formaterAsCurrency ? formater({value: pastValue}) : formater(pastValue)}
          </Text>
          <ArrowIcon size={13}/>
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultSightCreditCardConfigData[innerValue])}>
            {formaterAsCurrency ? formater({value: laterValue}) : formater(laterValue)}
          </Text>
        </Section>
      );
    }
  }
  return (
    <>
      {sightCreditCardConfigData && (
        <Section flexDir="column" gap="">
          <Section gap=".4rem" margin="1rem 0 0">
            <CreditCardIcon />
            <Header>Cartão recorrente à vista</Header>
          </Section>
          <Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Tempo de repasse
              </Text>
              {delayForRedeem}
            </Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Taxa
              </Text>
                {rate}
            </Section>
            <Section>
            </Section>
          </Section>
          <Divider />
        </Section>
      )}
    </>
  )
}